import { UserOrdersTable } from './components';
import { useDocuments } from '../DocumentsLayout';

const OrdersPage = () => {
  const data = useDocuments();

  return (
    <>
      {data?.currentUser?.orders && (
        <UserOrdersTable orders={data.currentUser.orders} />
      )}
    </>
  );
};

export default OrdersPage;
